// extracted by mini-css-extract-plugin
module.exports = {"postActionPage":"_1ik9r94xrPiRYpLR"};